import type { CalculatorResultData } from "@/models/CalculatorResult"

/**
 * Cilindro/eixo a exibir/desenhar pra um resultado: se tiver tabela por
 * degrau (toricSteps), usa o degrau RECOMENDADO (a lente de verdade que o
 * cirurgião vai pedir); senão cai pro valor base (T0, sem lente tórica
 * escolhida). Compartilhado entre o texto "Cyl" (ResultLens) e o desenho do
 * olho (CardResult), pra não duplicar essa regra em dois lugares.
 */
export function getDisplayAstigmatism(
    result: Pick<CalculatorResultData, 'cylinder' | 'axis' | 'toricSteps'>
): { cylinder?: number, axis?: number } {
    const recommended = result.toricSteps?.find(step => step.recommended)
    return {
        cylinder: recommended?.residualCylinder ?? result.cylinder,
        axis: recommended?.residualAxis ?? result.axis,
    }
}
